import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FreudButtonModule, FreudSelectModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { ContactSelectComponent } from './contact-select.component';

@NgModule({
	declarations: [ContactSelectComponent],
	imports: [
		CommonModule,
		FreudSelectModule,
		TranslateModule,
		ReactiveFormsModule,
		FreudButtonModule,
		FormsModule,
	],
	exports: [ContactSelectComponent],
})
export class ContactSelectModule {}
